import { curry } from 'ramda'

// Load libphonenumber-js since
// it is quite a large dependency
// and is only used in modals/forms.
const parsePhone = async (...args) => {
  let libphonenumber
  try {
    libphonenumber = await import('libphonenumber-js')
  } catch (e) {
    return null
  }
  const { parsePhoneNumberFromString } = libphonenumber
  return parsePhoneNumberFromString(...args)
}

const isValidRegex = curry((regex, value) => regex.test(value))

export const isValidEmail = isValidRegex(
  /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,8})+$/
)

export const isPhoneNumber = value => {
  if (!value) return false
  const cleaned = value.replace(/(\(|\)|\+|\s|-)/g, '')
  return !isNaN(Number(cleaned))
}

export const isLoginPhoneValid = async (phoneNumber = '') => {
  const phone = phoneNumber.replace(/[^(0-9+)]/g, '')
  const withPlus = !phone.startsWith('+') ? `+1${phone}` : phone
  const result = await isPhoneValid(withPlus)
  return result
}

export const isPhoneValid = async (phoneNumber = '') => {
  const phone = await parsePhone(phoneNumber)
  return phone && phone.isValid()
}
